import { CasesGeneralInformationFilter } from '../../../../../shared/types/modules/cases-general-information';

export const initialValues: CasesGeneralInformationFilter = {
    callId: '',
    account: '',
    typification1: '',
    typification2: '',
    typification3: '',
    typification4: '',
    typification5: '',
    user: [],
    endCreatedAt: undefined,
    startCreatedAt: undefined,
};
